import {AnySchema} from 'yup';
import {IValidationRule} from '../../../@interfaces/services/YupSchemeBuilder/IValidationRule';

export default abstract class AbstractRule implements IValidationRule {
	protected abstract name: string;
	protected defaultParameters: (string | number)[] = [];
	protected parameters: (string | number)[] = [];

	getName(): string {
		return this.name;
	}

	getDefaultParameters(): any[] {
		return this.defaultParameters;
	}

	getParameters(): any[] {
		return this.parameters;
	}

	abstract mutateScheme<S extends AnySchema>(scheme: S): S;

	mergeParameters(params: (string | number)[]): void {
		for (const i in params) {
			this.parameters[i] = params[i];
		}
	}

	parseRuleDeclaration(declaration: string): void {
		const [, paramsString] = declaration.split(':');
		const params = (paramsString || '').split(',');

		this.parameters = [...this.defaultParameters];
		for (const i in params) {
			this.parameters[i] = params[i];
		}
	}
}
